import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Tiles from "../utils/menuItems/MenuItems";
import Col from "react-bootstrap/esm/Col";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import LinkButton from "../utils/LinkButton";
import { Button } from "react-bootstrap";
import TimeTracking from "../utils/analytics/TimeTracking";

function Games() {
  const [data, setData] = useState([])
  const [gameLists, setGameLists] = useState([])
  const [filter, setFilter] = useState([])

  useEffect(() => {
    if(data.length == 0){
      getData()
    }
  },[])

  const getData = async () => {
    const response = await makeGetRequest(
      urls.gameList,
      "",
      true
    );
    setData(response.data)
    setFilter(response.data)
  }

  useEffect(() => {
    if(data != []){
      SortData()
    }
  },[data])

  const SortData = d => {
    let game_obj = {}
    let cate_list = []
    let displayed_game_list = []
    if(d == undefined){
      data.map(game => {cate_list.indexOf(game.category) === -1 && cate_list.push(game.category)})
      cate_list.map(cate => {let game_list = []
                              data.map((game) => {if(game.category == cate){game_list.push(game)}})
                              game_obj[cate] = game_list})
    }else{
      d.map(game => {cate_list.indexOf(game.category) === -1 && cate_list.push(game.category)})
      cate_list.map(cate => {let game_list = []
                              d.map((game) => {if(game.category == cate){game_list.push(game)}})
                              game_obj[cate] = game_list})
    }
    for(const [k,v] of Object.entries(game_obj)){
      displayed_game_list.push(
        <>
          <Button key={k + Math.random()} onClick={() => openGame(k)} style={{width:'100%',height:'150px',fontSize:'35px',marginBottom:'5px',textAlign:'center', backgroundColor:'#232771'}}>{k}</Button>
          <div id={k} style={{display:'none'}} key={k + Math.random()}>
            {v.map(game => { if (game.url.includes('https')){
                                return <Tiles
                                  url={'/games/external-games?game_url=' + game.url}
                                  title={game.name}
                                  key={game.key}
                                  backgroundC="#f8bbC9"
                                  width={'75%'}
                                  fontSize="25px"
                                  fontColor={'black'}
                                  difficulty={game.difficulty}
                                  itemkey = {game.key}
                                />}
                              else
                                return <Tiles
                                  url={game.url}
                                  title={game.name}
                                  key={game.key}
                                  backgroundC="#f8bbC9"
                                  width={'75%'}
                                  fontSize="25px"
                                  fontColor={'black'}
                                  difficulty={game.difficulty}
                                  itemkey = {game.key}
                                />
                            }
                            )}
            </div>
        </>
      )
    }
    displayed_game_list.sort((a, b) => {
      // Sort by category name
      if (a.props.children[0].props.children === "Just for Fun") return 1;
      if (b.props.children[0].props.children === "Just for Fun") return -1;
      return 0; // keep original order for other items
    });
    console.log(displayed_game_list)
    setGameLists(displayed_game_list)
  }

  const openGame = k => {
    let el = document.getElementById(k)
    if(el.style.display == 'none'){
      el.style.display = 'block'
      el.style.marginLeft = 'auto'
      el.style.marginRight = 'auto'
      el.style.textAlign = 'center'
    }else{
      el.style.display = 'none'
    }
  }

  const filterGames = diff => {
    let filtered_games = []
    if(diff != 'Clear'){
      filtered_games = filter.filter(game => game.difficulty == diff)
      SortData(filtered_games)
    }else{
      filtered_games = filter
      SortData(filtered_games)
    }
  }


  return (
    <>
      <Card
        bg="light-2"
        style={{
          marginTop: "25px",
          paddingBottom: "25px",
        }}
      >
        <Row >
          <Col xs={3} style={{paddingLeft:'35px',marginTop:'50px'}}>
            <h2>Filters:</h2>
            <Button variant="dark" onClick={() => filterGames('Clear')}>Clear</Button>
            <Row>
              <h5>Difficulty:</h5>
              <Button variant="info" style={{marginBottom:'5px'}} onClick={() => filterGames('Easy')}>Easy</Button>
              <Button style={{backgroundColor:'#f7f35b', color:'black', marginBottom:'5px'}} onClick={() => filterGames('Medium')}>Medium</Button>
              <Button style={{backgroundColor:'#ffa010', color:'black', marginBottom:'5px'}} onClick={() => filterGames('Hard')}>Hard</Button>
              <Button variant="danger" style={{marginBottom:'5px'}} onClick={() => filterGames('Very Hard')}>Very Hard</Button>
            </Row>
          </Col>
        <Col style={{width:'100%'}}>
            <h1 style={{textAlign:'center'}} key={'community_game_list_title'}>
              <b>Community Games</b>
            </h1>
            <div style={{overflowY:'scroll', height:window.innerHeight - 300}}>
              {gameLists && gameLists}
            </div>
        </Col>
        </Row>
        
      </Card>
    </>
  );
}

export default Games;
